import { grayColors, brandColors, textColors, extraColors } from './colors.mjs';

const darkThemeColors = {
    textColor: grayColors.white,
    invertedTextColor: grayColors.slate,
    mutedTextColor: grayColors.mist,
    mutedBackgroundColor: '#373737',
    buttonTextColor: grayColors.white,
    categoryTextColor: grayColors.white,
    backgroundColor: grayColors.slate,
    iconColor: grayColors.white,
    videoHeroTextColor: grayColors.white,
    weatherColor1: '#FFFF00',
    weatherColor2: '#FFFFFF',
    weatherColor3: '#3693FF',
    arrowColor: grayColors.white,
    lineSeparatorStrongColor: grayColors.white,
    lineSeparatorMutedColor: grayColors.darkGray,
    checkboxBorderColor: grayColors.darkGray,
    checkboxBorderHoverColor: grayColors.mist,
    searchBarIconColor: grayColors.white,
    navigationRegionBackground: `${grayColors.darkGray}1A`,
    storyContentHeaderColor: grayColors.white,
    storyContentLinkColor: brandColors.skyBlueLight,
    storyContentTableBorderColor: grayColors.white,
    relatedStoriesBackground: `${grayColors.mist}0D`,
    relatedStoriesHeading: grayColors.white,
    relatedStoriesTimestamp: grayColors.mist,
    mediaCardLoadingBackground: `${grayColors.mist}1A`
};
var darkThemeColors$1 = Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, brandColors), grayColors), textColors), extraColors), darkThemeColors);

export { darkThemeColors$1 as default };
//# sourceMappingURL=darkThemeColors.mjs.map
